export function ColorLegend() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-muted-foreground py-2">
      <div className="flex items-center gap-1.5">
        <div className="w-4 h-4 rounded bg-tile-correct border border-tile-correct" />
        <span>Correct</span>
      </div>
      <div className="flex items-center gap-1.5">
        <div className="w-4 h-4 rounded bg-tile-present border border-tile-present" />
        <span>Wrong spot</span>
      </div>
      <div className="flex items-center gap-1.5">
        <div className="w-4 h-4 rounded bg-tile-absent border border-tile-absent" />
        <span>Not in word</span>
      </div>
    </div>
  );
}
